import { useQuery } from '@apollo/client';
import { BLOG_POST_PAGE_QUERY } from '../../graphql/blog-queries';

export function useGetBlogPost(slug) {
    const { data, loading } = useQuery(BLOG_POST_PAGE_QUERY, { variables: { slug } });
    return { data, loading };
}
